import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=17122c7c"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports